import { CustomButton } from "../CustomButton";
import { useEffect, useState } from "react";
import { ExportDataIcon } from "../../images";
import { ExportAccountsCSVModal } from "../modal";
import { ReuseTooltip } from "../ReuseTooltip";
import { useAppSelector } from "../../../hooks";
import { selectPermissions } from "../../../features/permissionsSlice";

export const ExportAccountsDataBtn = ({
  setIsVisible,
  isDisabled,
  btnText,
  btnFullWidth,
}: {
  setIsVisible?: (visible: boolean) => void;
  isDisabled?: boolean;
  btnFullWidth?: boolean;
  btnText?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedExportContactsAccountsList } =
    useAppSelector(selectPermissions);

  useEffect(() => {
    setIsVisible && setIsVisible(isOpen);
  }, [isOpen]);

  return (
    <>
      <ReuseTooltip
        text={
          isDisabled
            ? "You haven’t analysed any company yet"
            : btnText
              ? ""
              : "Export accounts and contacts data in CSV format."
        }
        hideChildren={false}
        maxWidth={"156px"}
      >
        <CustomButton
          onClick={() => setIsOpen(true)}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#1D3E70"
          type="button"
          customSize="fit"
          fullWidth={btnFullWidth}
          style={{ padding: "8px" }}
          sx={{
            borderColor: "#1D3E70",
            minWidth: "fit-content",
            height: "42px",
          }}
          disabled={isDisabled || !isAllowedExportContactsAccountsList}
        >
          <ExportDataIcon
            color={
              isDisabled || !isAllowedExportContactsAccountsList
                ? "#BFC1C1"
                : undefined
            }
          />
          {btnText}
        </CustomButton>
      </ReuseTooltip>

      {isOpen && <ExportAccountsCSVModal onClose={() => setIsOpen(false)} />}
    </>
  );
};
